import React from "react"
import Raven from "raven-js";

import { Route, Switch } from "react-router-dom"
import { connect } from 'react-redux';

import { store, history } from './store/configureStore'
import { push } from 'react-router-redux';
import agent from './agent'
import AuxContainer from './containers/AuxContainer'

import { APP_LOAD, REDIRECT } from './constants/actionTypes';

import AMLogo from './assets/images/audition-magic-favicon.png';
import Footer from './components/Footer'


import NotFoundCointainer from './containers/NotFoundContainer'
import LandingContainer from './containers/LandingContainer'
import NewLandingContainer from './containers/NewLandingContainer'
import ArtistContainer from './containers/ArtistContainer'
import ClientContainer from './containers/ClientContainer'

import ClientLoginContainer from './containers/ClientLoginContainer'
import ClientProjectsListContainer from './containers/ClientProjectsListContainer'
import ClientProjectSettingsContainer from './containers/ClientProjectSettingsContainer'
import ArtistProjectConfirmation from './containers/ArtistProjectConfirmation'
import ProjectCheckinContainer from './containers/ProjectCheckinContainer'
import ForgotPassword from './containers/ForgotPassword'

import CheckinSuccess from './components/CheckinSuccess'

import PublicRegistrationPage from './containers/PublicRegistrationPage'
import ClientLandingPage from './containers/ClientLanding'
import Registration from './containers/Registration'
import ProjectDetails from './containers/ProjectDetails'
import CompanyReview from './containers/CompanyReview'
import CheckinArtist from './containers/CheckinArtist'
import Apply from './containers/Apply'
import DirectMedia from './components/DirectMedia'

import AgencyContainer from './containers/Agency'
import AgencyProfileForm from './containers/AgencyProfileForm'
import AgencyLoginContainer from './containers/AgencyLoginContainer'
import AgencyDashboard from './containers/AgencyDashboard'
import UpdateProfile from './containers/UpdateProfile'

import Appsignal from "@appsignal/javascript"
import { ErrorBoundary } from "@appsignal/react"
import { plugin } from "@appsignal/plugin-window-events"

class SentryBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Raven.captureException(error, { extra: errorInfo });
  }
  
  render() {
    if (this.state.error) {
      return (
        <div className="snap">
         <img src={AMLogo} />
          <div className="snap-message">
            <p>We're sorry - something's gone wrong.</p>
            <p>Our team has been notified, but click  <button  onClick={() => Raven.lastEventId() && Raven.showReportDialog()}>
              here
              </button> to fill out a report.
                  
            </p>
          </div>

        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

const FallbackComponent = () => (
  <div>Uh oh! There was an error :(</div>
)

window.appsignal = new Appsignal({ 
  key: "4ea67395-c8a3-47bf-b229-8305eafd6ce3",
  revision: '0.9.18'
})

window.appsignal.use(plugin({onerror: true, onunhandledrejection: true}))

class App extends React.Component {

  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      store.dispatch(push(nextProps.redirectTo))
      this.props.onRedirect();
    }
  }

  componentWillMount() {
    let clientToken = window.localStorage.getItem('jwt')
    if (clientToken != null) {
      clientToken = JSON.parse(window.localStorage.getItem('jwt'))
    }
    
    let artistInfo = window.localStorage.getItem('artist_jwt')
    console.log('artist-info', artistInfo)
    if (artistInfo) {
      try {
        artistInfo = JSON.parse(window.localStorage.getItem('artist_jwt'))
      } catch (err) {
        artistInfo = null
      }
    }
    
    if (clientToken || (artistInfo && artistInfo.artist) ) {
      agent.setToken(clientToken || artistInfo.artist.client || artistInfo.meta);
    }

    this.props.onLoad(clientToken, artistInfo)
  }

  render() {

    return (
      <div>
      <ErrorBoundary instance={window.appsignal} fallback={(error) => <FallbackComponent />}>
      <Switch>
      { 
        //<Route path="/" exact component={ LandingContainer } /> 
      }

      <Route path="/" exact component={ NewLandingContainer } />
      <Route path="/talent" exact component={ NewLandingContainer } />
      <Route path="/agent" exact component={ NewLandingContainer } />
      <Route path="/artist" component={ ArtistContainer } />
      <Route path="/client" component={ ClientContainer } />
      <Route path="/projects" exact component={ClientProjectsListContainer} />
      <Route path={`/projects/settings/:id`} exact component={ClientProjectSettingsContainer} />
      <Route path="/projects/confirmation" exact component={ArtistProjectConfirmation} />
      <Route path={`/projects/checkin/:id`} exact component={ProjectCheckinContainer} />
      <Route path={`/checkin/success`} exact component={CheckinSuccess} />

      <Route path="/public_registration" component={ PublicRegistrationPage } />
      <Route path={`/apply`} component={ Apply } />


      <Route path={`/agency/represented`} component={ AgencyContainer } />
      <Route path={`/agency/details/:id`} component={ AgencyProfileForm } />
      <Route path={`/agencylogin`} component={ AgencyLoginContainer } />
      <Route path={`/agencydashboard`} component={ AgencyDashboard } />
      <Route path={`/clientlanding`} component={ ClientLandingPage } />
      <Route path={`/registration`} component={ Registration } />
      <Route path={`/projectdetails/:id`} component={ ProjectDetails } />
      <Route path={`/companyreview`} component={ CompanyReview } />
      <Route path={`/checkinartist`} component={ CheckinArtist } />

      <Route path={`/forgotpassword`} component={ ForgotPassword } />
      <Route path={`/updateprofile`} component={ UpdateProfile } />

      <Route path={`/upload/:id`} component={ DirectMedia } />      
      {
        // Todo: create a public api to retrieve the project details for public registration
        // <Route path="/:company/:project/:token/apply" component={ Sample }></Route>
      }

      { /* Finally, catch all unmatched routes */ }
      <Route component={NotFoundCointainer} />
      </Switch>

      {
        this.props.location.pathname == '/' || 
        this.props.location.pathname == '/registration' || 
        this.props.location.pathname.indexOf('projectdetails') >= 1 ||
        this.props.location.pathname == '/companyreview' ||
        this.props.location.pathname == '/agent' ||
        this.props.location.pathname == '/talent' ||
        <Footer className="footer text-center">
          <div><img src={AMLogo} alt=""/></div>
          Powered by Audition Magic
        </Footer>
      }
      </ErrorBoundary>
      </div>
    )
  }

}

// export default App

const mapStateToProps = state => ({
  ...state.auth,
  ...state.common,
})

const mapDispatchToProps = dispatch => ({
  onLoad: (clientToken, artistInfo) =>
    dispatch({ type: APP_LOAD, clientToken, artistInfo }),
  onRedirect: () =>
    dispatch({ type: REDIRECT }),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)






// WEBPACK FOOTER //
// ./src/App.js